import * as React from "react";

import Modal from "../modal";

interface Plus24hrTimeRangeFilterModalProps {
    header: string;
    show: boolean;
    from: string;
    to: string;
    onClose: (event?) => void;
    onChange: (from, to) => void;
    onClear: () => void;
}

export const Plus24hrTimeRangeModal = ({ header, show, onClose, onChange, onClear, from, to }: Plus24hrTimeRangeFilterModalProps) => {
    const [currentFrom, setFrom] = React.useState(from ? from : undefined);
    const [currentTo, setTo] = React.useState(to ? to : undefined);
    const [isValidFrom, setIsValidFrom] = React.useState(true);
    const [isValidTo, setIsValidTo] = React.useState(true);

    React.useEffect(() => {
        setIsValidFrom(true);
        setIsValidTo(true);

        if (show) {
            setFrom(from ?? undefined);
            setTo(to ?? undefined);
        } else {
            setFrom(undefined);
            setTo(undefined);
        }
    }, [show, from, to]);

    const handleChangeFrom = (target: HTMLInputElement & EventTarget) => {
        setFrom(target.value);
        if (target.validity.patternMismatch || !target.validity.valid) {
            setIsValidFrom(false);
            return;
        }

        setIsValidFrom(true);
    }

    const handleChangeTo = (target: HTMLInputElement & EventTarget) => {
        setTo(target.value);
        if (target.validity.patternMismatch || !target.validity.valid) {
            setIsValidTo(false);
            return;
        }

        setIsValidTo(true);
    }

    const handleChange = (fromArg, toArg) => {
        onChange(fromArg, toArg);
    };

    const handleApply = (event?) => {
        onClose(event);
        handleChange(currentFrom, currentTo);
    };

    const handleClear = () => {
        onClear?.();
        onClose?.();
    };

    const handleClose = (event?) => {
        onClose(event);
    }

    return (
        <Modal show={show} closeModalHandler={handleClose} header={header}>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-6 form-group">
                        <label>From</label>
                        <input type="text" pattern="^[0-9]{2}:[0-9]{2}:[0-9]{2}(?:\.[0-9]{3})?$" placeholder="HH:mm:ss.fff" className={isValidFrom ? "form-control" : "form-control input-validation-error"}
                            value={currentFrom}
                            onChange={(e) => handleChangeFrom(e.target)} />
                    </div>
                    <div className="col-md-6 form-group">
                        <label>To</label>
                        <input type="text" pattern="^[0-9]{2}:[0-9]{2}:[0-9]{2}(?:\.[0-9]{3})?$" placeholder="HH:mm:ss.fff" className={isValidTo ? "form-control" : "form-control input-validation-error"}
                            value={currentTo}
                            onChange={(e) => handleChangeTo(e.target)} />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" disabled={!isValidFrom || !isValidTo} onClick={handleApply}>
                    OK
                </button>
                <button className="btn btn-danger" onClick={handleClear}>
                    Clear
                </button>
            </div>
        </Modal>
    );
}
